import { IMinCostPerSquareFootController } from '../Interfaces/ControllerInterfacesBarrel';

import {
    MinCostPerSquareFoot,
    MinCostPerSquareFootWithId,
} from "@app/models/api";

export default class MockMinCostPerSquareFootController implements IMinCostPerSquareFootController {

    public constructor() {      
    }

    public async addMinCostPerSquareFoot(
        minCostPerSquareFoot: MinCostPerSquareFoot
    ): Promise<MinCostPerSquareFootWithId> {
        throw new Error("Method not implemented.");
    }

    public async updateMinCostPerSquareFoot(
        minCostPerSquareFootId: number,
        minCostPerSquareFoot: MinCostPerSquareFoot
    ): Promise<MinCostPerSquareFootWithId> {    
        throw new Error("Method not implemented.");
    }

    public async deleteMinCostPerSquareFoot(
        minCostPerSquareFootId: number
    ): Promise<void> {
        throw new Error("Method not implemented.");
    }

    public async getAllMinCostPerSquareFootByVersionId(
        versionId: number
    ): Promise<MinCostPerSquareFootWithId[]> {
        throw new Error("Method not implemented.");
    }

    public async getMinCostPerSquareFoot(
        minCostPerSquareFootId: number
    ): Promise<MinCostPerSquareFootWithId> {
        throw new Error("Method not implemented.");
    }
}